module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "widget"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 fld"
  }, [_c('div', {
    staticClass: "content"
  }, [(!_vm.process_request_sent) ? _c('div', {
    staticClass: "background-white p30 mb30"
  }, [_c('h3', {
    staticClass: "page-title"
  }, [_vm._v("File Complaint")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#f52323"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cninsurance_data.cninsurance_form),
      expression: "cninsurance_data.cninsurance_form"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Enter the InsureMoto Form Policy ID"
    },
    domProps: {
      "value": (_vm.cninsurance_data.cninsurance_form)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cninsurance_data.cninsurance_form = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cninsurance_data.cninsurance_complaint_title),
      expression: "cninsurance_data.cninsurance_complaint_title"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Enter Title of Complaint"
    },
    domProps: {
      "value": (_vm.cninsurance_data.cninsurance_complaint_title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cninsurance_data.cninsurance_complaint_title = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(2), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cninsurance_data.cninsurance_complaint),
      expression: "cninsurance_data.cninsurance_complaint"
    }],
    staticClass: "form-control",
    staticStyle: {
      "height": "250px"
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter Complaint Details"
    },
    domProps: {
      "value": (_vm.cninsurance_data.cninsurance_complaint)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cninsurance_data.cninsurance_complaint = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    staticStyle: {
      "display": "none",
      "padding": "1em 5px",
      "border": "#f3c0c0 1px dashed"
    }
  }, [(!_vm.remove_files && (Object.keys(_vm.files_info).length > 0)) ? _c('button', {
    staticClass: "btn btn-primary btn-xs",
    staticStyle: {
      "margin-top": "1em",
      "margin-bottom": "1em",
      "background-color": "#d84040",
      "float": "right"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.setRemoveFiles
    }
  }, [_vm._v("Remove files")]) : _vm._e(), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('label', [_vm._v(" Add Media")]), _vm._v(" "), _c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "id": "fileElem02",
      "multiple": "",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.setOnFileChange($event, _vm.cninsurance)
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-xs",
    staticStyle: {
      "background-color": "#e7c619",
      "color": "#000000"
    },
    attrs: {
      "id": "fileSelect"
    }
  }, [_vm._v("Select some files")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(4)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both",
      "display": "none",
      "margin-top": "2em"
    },
    attrs: {
      "id": "stackFiles02"
    }
  }, [(Object.keys(_vm.files_info).length > 0) ? _c('div', [_vm._l((_vm.files_info), function(file_info, index) {
    return _c('p', [_c('span', {
      attrs: {
        "id": 'filsdaw' + index
      }
    }), _vm._v(" "), _c('button', {
      staticClass: "btn btn-primary btn-xs",
      staticStyle: {
        "background-color": "#d84040",
        "font-size": "13px"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.removeFileUpload(file_info)
        }
      }
    }, [_vm._v("Tap to Remove")])])
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-xs",
    staticStyle: {
      "margin-top": "1em",
      "margin-bottom": "1em",
      "background-color": "#d84040",
      "float": "right"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.unsetRemoveFiles
    }
  }, [_vm._v("Cancel Remove")])], 2) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "left"
  }, [_c('p', {
    staticStyle: {
      "color": "#f52323"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-xl",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.submitCNInsuranceForm
    }
  }, [_vm._v("Send Complaint")])])]) : _c('div', {
    staticClass: "background-white p30 mb30"
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._m(5), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-top": "1em",
      "color": "#22baae",
      "font-weight": "bolder"
    }
  }, [_vm._v("Your Complaint has been sent.")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-xl",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.reset()
      }
    }
  }, [_vm._v("OK")])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Enter your InsureMoto Form Policy ID"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Complaint Title"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Complaint"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    attrs: {
      "id": "fileList02"
    }
  }, [_c('p', [_vm._v("No files selected!")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "font-size": "13px",
      "color": "#d84040"
    }
  }, [_vm._v("Maximum number of Photos allowed: "), _c('b', [_vm._v("10")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticStyle: {
      "border": "solid #22baae 8px",
      "border-radius": "50%",
      "width": "100px",
      "height": "180px",
      "padding": "5.5em 1em 1em 1em"
    }
  }, [_c('i', {
    staticClass: "fa fa-check",
    staticStyle: {
      "text-align": "center",
      "font-size": "7.2em",
      "color": "#22baae"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-557b28db"}!./src/templates/CNinsuranceFileComplaint/template.html
// module id = 293
// module chunks = 0